import { SET_CURRENT_VALUES } from '../actionTypes';
import { actions } from '../reducer';

export default (values) => actions[SET_CURRENT_VALUES](values);
